var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftArrow = function SvgLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.958 3.111.629.629-4.154 4.153 4.154 4.154-.629.628-4.782-4.782z",
    fill: "#B7B7B7",
    fillRule: "evenodd"
  })));
};
export { SvgLeftArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Im0xMC45NTggMy4xMTEuNjI5LjYyOS00LjE1NCA0LjE1MyA0LjE1NCA0LjE1NC0uNjI5LjYyOC00Ljc4Mi00Ljc4MnoiIGZpbGw9IiNCN0I3QjciIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4K";